import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTDropdown {
    $onInit() {
        if (!this.preselectedOption) {
            this.setSelectedOption(this.options[0]);
        } else {
            this.setSelectedOption(this.preselectedOption);
        }
    }

    setShownState(state) {
        this.showOptions = state;
    }

    setSelectedOption(selectedOption) {
        this.selectedOption = selectedOption;
    }

    closeOptions() {
        this.setShownState(false);
    }

    onClickOutside() {
        this.setShownState(false);
    }

    onButtonClick() {
        this.setShownState(!this.showOptions);
    }

    onOptionClick(option) {
        if (!this.preselectedOption) {
            this.setSelectedOption(option);
        }

        this.closeOptions();
        this.onOptionSelect({ option });
    }
}

export const TFTDropdownConfiguration = {
    template,
    controller: TFTDropdown,
    bindings: {
        options: '<',
        preselectedOption: '<?',
        onOptionSelect: '&',
    },
    controllerAs: 'dropdownCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftDropdown', TFTDropdownConfiguration);
